import { ArrowCircleLeft } from '@remarkable/ark-icons';
import { useRouter } from '@tanstack/react-router';

import { Link2 } from './Link2';

export const BackLink = ({
  className,
  componentLocation,
}: {
  className: string;
  componentLocation: string | undefined;
}) => {
  const router = useRouter();

  return (
    <Link2
      as="button"
      onClick={() => router.history.back()}
      className={className}
      componentLocation={componentLocation}
    >
      <ArrowCircleLeft />
      <span>Back</span>
    </Link2>
  );
};
